export default function (app) {
    app.config.globalProperties.$theme = {
        "bg-primary": "dark:bg-gray-600 bg-white",
        home: {
            container: 'h-full w-full dark:bg-gray-600 md:rounded-[1.5rem] grid grid-rows-27 grid-cols-13'
        },
        home_item: {
            container: `
                shadow-lg rounded-xl bg-white dark:bg-gray-800
                dark:text-white flex flex-col justify-between py-4 px-2
                grid grid-cols-2 grid-rows-2 cursor-pointer
            `,
            title: 'text-lg font-bold row-start-1 col-start-1 col-end-4',
            subtitle: 'text-small font-light row-start-2 col-start-1 col-end-3',
            button: {
                container: `
                    flex items-center justify-center
                    dark:bg-white bg-primary text-white dark:text-gray-500 font-bold p-1
                    rounded-lg row-start-1 row-end-3 my-auto ml-auto col-start-3 col-end-4 w-8 h-8
                    `,
                text: ''
            }
        }
    }
}
